<template>
  <div :class="[$style.container, $style.modal]">
    <ModalHeader
      :handleClose="handleClose"
      :showClose="true"
    />
    <div :class="$style.modalBody">
      <img
        :class="$style.thankYouIcon"
        src="img/icons/icon-submit-feedback.svg"
      >
      <h2 :class="$style.thankYouHeader">
        Thank you for your input!
      </h2>
      <p :class="$style.thankYouDescription">
        We will be in touch as this idea moves forward.
      </p>
    </div>
    <ModalFooter
      :centered="true"
      :handleClose="handleClose"
      :handleMainAction="handleClose"
      mainActionText="ok, got it"
    />
  </div>
</template>

<script>
import ModalEventBus from 'components/Modal/ModalEventBus';
import ModalFooter from 'components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'components/Modal/ModalComponents/ModalHeader.vue';

export default {
  name: 'ThankYouSubmitIdeaModal',

  components: {
    ModalFooter,
    ModalHeader,
  },

  methods: {
    handleClose() {
      ModalEventBus.close();
    },
  },
};
</script>

<style scoped module>
@import "../components/FormValidation/css/formFields.css";
@import "./SupportModals.css";

.modalBody {
  padding: 85px;
}

.thankYouIcon {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.priorityButton {
  background-color: var(--jcPrimary);
  float: right;
  margin: 10px 0 0 10px;
  width: 121px;
}

</style>
